import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from './providers';
import { adminEnvironment } from '@/config/environment';
import { AppRouter } from '@/router';

export function App() {
  return (
    <AppProviders>
      <BrowserRouter basename={adminEnvironment.routerBasePath}>
        <AppRouter />
      </BrowserRouter>
    </AppProviders>
  );
}
